import classes from './CommonButton.module.css';

const CommonButton = ({ icon, text, onClick, className, disabled }) => {
    return (
        <button
            className={`${classes.wrapper} ${className} d-flex align-items-center gap-2`}
            onClick={onClick}
            disabled={disabled}
        >
            {icon} {text}
        </button>
    );
}

export default CommonButton;